import React, { useEffect } from 'react';
import styles from './home.module.css';
import HeaderMenu from '../../components/header/header';
import '@mantine/core/styles.css';
// import { useMediaQuery } from "@mantine/hooks";
import Footer from '../../components/footer/footer';
import HeroSection from '../../components/hero_section/herosection';
import ProductOptions from '../../components/product_options/product_options';
import InfiniteSlide from '../../components/infinite_slide/infinite_slide';
import ImageCarousel from '../../components/image_carousel/image_carousel';
import TitiRosa from '../../components/titirosa/titirosa';
import GabiPili from '../../components/gabipili/gabipili';
import ComoPedir from '../../components/como_pedir/como_pedir';
import Alfajores from '../../components/alfajores/alfajores';
import AlfajoresMundial from '../../components/alfajores_mundial/alfajoresMundial';
import TresTortas from '../../components/tres_tortas/tres_tortas';
import Navidad from '../../components/navidad/navidad';
import LimaMaracuya from '../../components/lima_maracuya/lima_maracuya';
// import DiaDeLaMadre from '../../components/dia_de_la_madre/dia_de_la_madre';


function Home() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.home_container}>
            <HeroSection />
            <div>
                <HeaderMenu />

                {/* <Navidad />

                <InfiniteSlide /> */}

                {/* <DiaDeLaMadre />

                <InfiniteSlide /> 
                <AlfajoresMundial/>

                <InfiniteSlide /> */}

                <ProductOptions />

                <InfiniteSlide />

                {/* <LimaMaracuya /> */}

                {/* <InfiniteSlide /> */}

                <TresTortas />

                <InfiniteSlide />

                {/* <Alfajores /> */}

                {/* <InfiniteSlide /> */}

                <ImageCarousel />

                <TitiRosa />

                <GabiPili />

                <ComoPedir />
            </div>
            <Footer />
        </div>
    );
}

export default Home;
